@if (messageShow) {
<div
  class="dc-message"
  [ngClass]="{
    'dc-message-success': type === 'success',
    'dc-message-error': type === 'error',
    'dc-message-warning': type === 'warning',
    'dc-message-info': type === 'info',
    'dc-message-default': type === 'default'
  }"
>
  <!-- ICON -->
  <img
    [src]="iconPath"
    class="dc-message-icon"
    [ngClass]="!content.title ? 'mt-0.5' : ''"
  />

  <!-- CONTENT -->
  <div class="grid-cols-1 text-dc-black">
    @if (content.title) {
    <div class="dc-message-title" [innerHTML]="content.title | translate"></div>
    } @if (content.message) {
    <div
      class="dc-message-text"
      [innerHTML]="displayContentMessage"
      (click)="onClick($event)"
    ></div>
    }

    <!-- Sections -->
    @for (section of content.sections; track section) {
    <div class="mt-4">
      <div
        class="dc-message-title"
        [innerHTML]="section.title | translate"
      ></div>

      @for (item of section.items; track item) {
        @if(section.items && section.items.length > 0){
          <li
            class="dc-message-text list-disc m-4 cursor-pointer"
            [innerHTML]="item | translate"
            (click)="itemClicked(item)"
          ></li>
        }@else{
          <p class="dc-message-text" [innerHTML]="item | translate"></p>
        }
      }
    </div>
    }

    <!-- BUTTON AREA  card-edge-cut-white btn-edge-cut -->
    @if (showbutton || buttonText) {
    <div class="dc-message-actions">
      @if (showbutton) {
      <app-button
        classesName="btn-edge-cut"
        [label]="buttonText"
        (onBtnClick)="onClick($event)"
      >
      </app-button>
      } @else {
      <div
        class="font-semibold text-dc-dark-blue cursor-pointer"
        (click)="onClick($event)"
      >
        {{ buttonText }}
      </div>
      @if(startNewText){
      <div
        class="font-semibold text-dc-dark-blue cursor-pointer py-2"
        (click)="onClick('star-new')"
      >
        {{ startNewText }}
      </div>
      } }
    </div>
    }
  </div>
</div>

}
